import { useOutlet } from "react-router";
import styled from "styled-components";

import BimClassInventory from "./BimClassInventory";
import { CssSectionCard } from "../../components/styles";
import {
    useUnsavedChangesRefs,
    type UnsavedChangesContext,
} from "../../modules/unsaved-changes";

const StyledWithBimClassInventory = styled.div`
    background: #fafbfc;
    box-sizing: border-box;
    display: flex;
    height: 100vh;
    overflow: hidden;
    padding: 20px;

    & > * {
        flex: 1;
        min-height: 0;
        min-width: 0;
    }

    .section-card {
        ${ CssSectionCard }
    }
`;

export type BimClassOutletContext = UnsavedChangesContext;

export default function WithBimClassInventory() {
    const guard = useUnsavedChangesRefs();

    const outlet = useOutlet(guard satisfies BimClassOutletContext);

    return (
        <StyledWithBimClassInventory>
            {
                outlet ?? (
                    <div className="section-card">
                        <BimClassInventory guard={ guard } />
                    </div>
                )
            }
        </StyledWithBimClassInventory>
    );
}
